import * as moment from 'moment';
import AuthApi from '../api/auth';
import store from "../store/store";
import {router} from "../router";

const SecureLS = require('secure-ls');
const SecureStore = new SecureLS({encodingType: 'aes'});
const format = 'YYYY-MM-DD HH:mm:ss';

export default class vueAuth {

    static setToken(token) {
        let tokenProps = {
            expiresOn: moment().add(token.expires_in, 's').format(format),
            accessToken: token.access_token,
            refreshToken: token.refresh_token
        };
        SecureStore.set('auth_token', JSON.stringify(tokenProps));
    }

    /*
      Get the access token from storage
     */
    static getToken() {
        let tokenStr = SecureStore.get('auth_token');
        try {
            let token = JSON.parse(tokenStr);
            if (moment(token.expiresOn).isBefore(moment().format(format))) {
                this.removeToken();

                return false;
            }
            return token;
        } catch (e) {
            return false
        }
    }

    static removeToken() {
        localStorage.removeItem('auth_token');
    }

    static getFromRefresh() {
        let refresh = this.getToken();
        return AuthApi.getTokenFromRefresh({
            endPoint: '/clients/web/admin/refresh',
            token: refresh.refreshToken
        }).then((result) => {
            // Save the new token on local storage
            store.dispatch('setTokens', result.data);
            store.commit('isAuthenticated', {state: true});

            return result.data.access_token;
        }).catch(() => {
            /**
             * We weren't able to refresh the token so the best thing to do is
             * logout the user (removing any user information from storage)
             * and redirecting to login page
             */
            store.dispatch('logOut', {
                endPoint: 'logout',
                options: {}
            });
            return false;
        });
    }
}
